module.exports = __webpack_public_path__ + "static/media/curva-topo-creme.6aae3456.svg";